import { render, staticRenderFns } from "./CreateTicketPage.vue?vue&type=template&id=05b6a123&"
import script from "./CreateTicketPage.vue?vue&type=script&lang=ts&"
export * from "./CreateTicketPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports